// extracted by mini-css-extract-plugin
export default {"Conseils":"EditionConseilSeance_Conseils__Q8KRw","Boutons":"EditionConseilSeance_Boutons__LVI9u"};